import React from 'react';
import { useNavigate } from 'react-router-dom';
import Separator from '../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { IAccountManagementCreateUser } from '../index';
import { useAccountManagementProvider } from '../../../../../context/accountManagement';

interface AccountManagementPrevUser {
  handleBack: () => void;
  state: IAccountManagementCreateUser;
}

function AccountManagementPrevUser({ handleBack, state }: AccountManagementPrevUser) {
  const navigate = useNavigate();
  const { handleShowTable } = useAccountManagementProvider();

  const handleConfirm = () => {
    handleShowTable(true);
    navigate('/infoTrac/account-management/', { replace: true });
  };

  return (
    <>
      <div className="grid grid-cols-[220px,auto] gap-[15px]">
        <div>Primary External User ID:</div>
        <div className="opacity-60">{state.primaryUserId}</div>
      </div>
      <div className="grid grid-cols-[220px,auto] gap-[15px]">
        <div>Secondary External User ID:</div>
        <div className="opacity-60">{state.secondaryUserId}</div>
      </div>
      <div className="grid grid-cols-[220px,auto] gap-[15px]">
        <div>First Name:</div>
        <div className="opacity-60">{state.firstName}</div>
      </div>
      <div className="grid grid-cols-[220px,auto] gap-[15px]">
        <div>Last Name:</div>
        <div className="opacity-60">{state.lastName}</div>
      </div>
      <div className="grid grid-cols-[220px,auto] gap-[15px]">
        <div>Type:</div>
        <div className="opacity-60">{state.type}</div>
      </div>
      <Separator className="mt-[20px]" />
      <div className="flex justify-between items-center gap-[20px] pt-[10px]">
        <Button variant="link" onClick={handleBack} className="flex gap-[10px] items-center px-0">
          <Icons.ArrowRight className="rotate-180" />
          Change
        </Button>
        <Button onClick={handleConfirm} className="flex gap-[10px] items-center">
          <Icons.SaveFilled className="opacity-60 w-[20px] h-[20px]" />
          Confirm
        </Button>
      </div>
    </>
  );
}

export default AccountManagementPrevUser;
